import { ControlLabelRoot } from 'ui/control-label/control-label.styles';
import type {
  ControlLabelProps,
  ControlLabelSize,
} from 'ui/control-label/control-label.types';

const LABEL_VARIANT = {
  small: 'body2',
  medium: 'body1',
} as const satisfies Record<ControlLabelSize, 'body1' | 'body2'>;

const ControlLabel = ({
  control,
  label,
  size,
  disabled,
  gap,
  sx,
}: ControlLabelProps) => (
  <ControlLabelRoot
    controlSize={size}
    labelGap={gap}
    control={control}
    label={label}
    disabled={disabled}
    sx={sx}
    slotProps={{ typography: { variant: LABEL_VARIANT[size] } }}
  />
);

export default ControlLabel;
